/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { type QueryFunctionContext } from '@tanstack/react-query';

import { recordSnapshotLastSeq } from '../../nats/snapshot-seq-store.js';

import { fetchWithHttpTelemetry } from '../../transport/http-request.js';

import { throwHttpError } from '../../core/http-error.js';

import type { GetPlatformConfigRow } from '../openapi-types.gen.js';

import type { EntityKeyFactory, HookSpec } from '../../types/HookSpec.js';
import type { JsonSerialisableArgs } from '../../types/JsonSerialisableArgs.js';


// ─── useGetPlatformConfig ────────────────────────────────────────────────────────────

export interface useGetPlatformConfigArgs { readonly kind?: string; readonly fields?: readonly ('marketConfig' | 'giftConfig' | 'giftFeeBps')[]; }


async function _useGetPlatformConfigQueryFn(
  args: useGetPlatformConfigArgs,
  ctx: QueryFunctionContext,
): Promise<GetPlatformConfigRow | null> {
  const url = '/v1/platform-config';
  const params = new URLSearchParams();
  if (args.fields !== undefined) params.set('fields', args.fields.join(','));
  if (args.kind !== undefined) params.set('kind', String(args.kind));
  const sep = url.includes('?') ? '&' : '?';
  const full = params.size > 0 ? `${url}${sep}${params.toString()}` : url;
  const res = await fetchWithHttpTelemetry({
    operationName: 'useGetPlatformConfig',
    routeTemplate: '/v1/platform-config',
    requestKind: 'query',
    method: 'GET',
    url: full,
    signal: ctx.signal,
    init: {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
      ...(ctx.signal !== undefined ? { signal: ctx.signal } : {}),
    },
  });
  // A signed-out / session-expired caller gets 401 — that is a normal
  // "anonymous" state. A 403 retains its canonical error envelope.
  if (res.status === 401) return null;
  if (!res.ok) await throwHttpError('GET', full, res);
  const json = (await res.json()) as unknown;
  recordSnapshotLastSeq(ctx.queryKey, json);
  const data =
    json !== null && typeof json === 'object' && 'data' in json
      ? (json as { data: unknown }).data
      : json;
  return data as GetPlatformConfigRow;
}


const _useGetPlatformConfigFactory = Object.assign(
  (args: useGetPlatformConfigArgs) => ({
    queryKey: ['platform-config', 'detail', { kind: args.kind ?? null }, args.fields ?? []] as readonly unknown[],
    queryFn: (ctx: QueryFunctionContext) => _useGetPlatformConfigQueryFn(args, ctx),
    staleTime: 300000,
    // structuralSharing kept ON (TanStack default). The codegen-emitted
    // applyEvent already preserves row references for unchanged rows;
    // structural sharing on top lets per-card `select` selectors
    // short-circuit when their row hasn't changed, avoiding cascade
    // re-renders of every list child on each patch.
    meta: {
      realtime: false,
      pollingManaged: true,
      specName: 'useGetPlatformConfig',
      viewerSensitive: false,
      persist: true,
    } as const,
  }),
  {
    __brand: 'EntityKeyFactory' as const,
    prefix: () => ['platform-config', 'detail'] as readonly unknown[],
  },
) as unknown as EntityKeyFactory<useGetPlatformConfigArgs, GetPlatformConfigRow>;


export const useGetPlatformConfigSpec = {
  __brand: 'HookSpec' as const,
  path: '/v1/platform-config',
  method: 'GET' as const,
  kind: 'detail' as const,
  mounting: { kind: 'singleton' as const, allowsPerEntity: false },
  entityKeys: { detail: _useGetPlatformConfigFactory },
  parseInput: (raw: unknown): useGetPlatformConfigArgs => raw as useGetPlatformConfigArgs,
  parseResponse: (raw: unknown): GetPlatformConfigRow => raw as GetPlatformConfigRow,
  specName: 'useGetPlatformConfig' as const,
  polling: { hasNats: false, intervalMs: false } as const,
  viewerSensitive: false as const,
  nonpersistent: false as const,
} as unknown as HookSpec<JsonSerialisableArgs, GetPlatformConfigRow>;
